import * as React from 'react';

const IconRef = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#1B1F23" />
      <path
        d="M5.19527 3.75H8.88461L11.4453 6.31066V12C11.4453 12.1381 11.3333 12.25 11.1953 12.25H5.19527C5.0572 12.25 4.94527 12.1381 4.94527 12V4C4.94527 3.86193 5.0572 3.75 5.19527 3.75Z"
        stroke="#F9F9FB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-3-inside-1" fill="white">
        <path fill-rule="evenodd" clipRule="evenodd" d="M8.19527 4.01538V6.68205H10.8619" />
      </mask>
      <path
        d="M9.69527 4.01538C9.69527 3.18695 9.0237 2.51538 8.19527 2.51538C7.36685 2.51538 6.69527 3.18695 6.69527 4.01538H9.69527ZM8.19527 6.68205H6.69527C6.69527 7.51047 7.36685 8.18205 8.19527 8.18205V6.68205ZM10.8619 8.18205C11.6904 8.18205 12.3619 7.51047 12.3619 6.68205C12.3619 5.85362 11.6904 5.18205 10.8619 5.18205V8.18205ZM6.69527 4.01538V6.68205H9.69527V4.01538H6.69527ZM8.19527 8.18205H10.8619V5.18205H8.19527V8.18205Z"
        fill="#F9F9FB"
        mask="url(#path-3-inside-1)"
      />
    </svg>
  );
};

export default IconRef;
